import api from "@/lib/api";

// Attach current hotel via query if user has one
function activeHotelId() {
  if (typeof document === "undefined") return null;
  const c = document.cookie.split(";").map((x) => x.trim()).find((x) => x.startsWith("active_hotel_id="));
  return c ? decodeURIComponent(c.split("=")[1]) : null;
}
const P = () => ({ params: activeHotelId() ? { hotel_id: activeHotelId() } : {} });

export const hkAPI = {
  missionControl: () => api.get("/housekeeping/mission-control", P()).then((r) => r.data),
  assign:         (taskId, payload) => api.post(`/housekeeping/tasks/${taskId}/assign`, payload).then((r) => r.data),
  reassign:       (taskId, payload) => api.post(`/housekeeping/tasks/${taskId}/reassign`, payload).then((r) => r.data),
};
